/**
 * @generated SignedSource<<51c5b6f5fb59f38618a72a15cb30257b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArticlesSearchContainerQuery$variables = {
  category?: string | null;
  count: number;
  cursor?: any | null;
  searchTerm?: string | null;
};
export type ArticlesSearchContainerQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ArticlesSearchContainer_query">;
};
export type ArticlesSearchContainerQuery = {
  response: ArticlesSearchContainerQuery$data;
  variables: ArticlesSearchContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "category"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Literal",
    "name": "capabilityFilter",
    "value": [
      "BASIC",
      "FULLY_FEATURED"
    ]
  },
  {
    "kind": "Variable",
    "name": "categoryFilter",
    "variableName": "category"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Variable",
    "name": "searchPlain",
    "variableName": "searchTerm"
  },
  {
    "kind": "Literal",
    "name": "sortBy",
    "value": "FIRST_PUBLICATION_DATE_DESC"
  },
  {
    "kind": "Literal",
    "name": "statusFilter",
    "value": "PUBLISHED"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ArticlesSearchContainerQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ArticlesSearchContainer_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ArticlesSearchContainerQuery",
    "selections": [
      {
        "alias": "articles",
        "args": (v4/*: any*/),
        "concreteType": "ArticlesConnection",
        "kind": "LinkedField",
        "name": "filterArticles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticlesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Article",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "capability",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": "primaryCategory",
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "categoryByPrimaryCategory",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "teaserImage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publicationDate",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "articles",
        "args": (v4/*: any*/),
        "filters": [
          "searchPlain",
          "categoryFilter",
          "capabilityFilter",
          "statusFilter",
          "sortBy"
        ],
        "handle": "connection",
        "key": "ArticlesSearchContainer_articles",
        "kind": "LinkedHandle",
        "name": "filterArticles"
      }
    ]
  },
  "params": {
    "cacheID": "ff5d040b893fb4e53106b12ece539b99",
    "id": null,
    "metadata": {},
    "name": "ArticlesSearchContainerQuery",
    "operationKind": "query",
    "text": "query ArticlesSearchContainerQuery(\n  $count: Int!\n  $cursor: Cursor\n  $searchTerm: String\n  $category: String\n) {\n  ...ArticlesSearchContainer_query\n}\n\nfragment ArticleSearchItem_article on Article {\n  rowId\n  title\n  capability\n  status\n  primaryCategory: categoryByPrimaryCategory {\n    rowId\n    title\n    color\n    id\n  }\n  teaserImage\n  publicationDate\n}\n\nfragment ArticlesSearchContainer_query on Query {\n  articles: filterArticles(first: $count, after: $cursor, searchPlain: $searchTerm, categoryFilter: $category, capabilityFilter: [BASIC, FULLY_FEATURED], statusFilter: PUBLISHED, sortBy: FIRST_PUBLICATION_DATE_DESC) {\n    totalCount\n    pageInfo {\n      hasNextPage\n      startCursor\n      endCursor\n    }\n    edges {\n      node {\n        rowId\n        ...ArticleSearchItem_article\n        id\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aae73e3d0f25efeb1fac3aec65842d35";

export default node;
